
import React, { forwardRef } from "react";
import { ColourPallette } from "./ColourPallette";
const PageOutline = ({ height, page, children }) => {
    const pageStyle = {
        height: height + "%",
    };
    return (<div style={pageStyle} className="pdf-overview-page">
        <div className="pdf-overview-page-inner">{children}</div>
        <div className="pdf-overview-page-number">{page}</div>
    </div>);
};
const PageLine = ({ offset, children, height }) => {
    const pageStyle = {
        top: offset + "%",
        height: height + "%"

    };
    return (<div style={pageStyle} className="pdf-overview-line" >{children}</div>);
};
const PageSegment = ({ width, highlight }) => {
    var color = ColourPallette[highlight.comment.type];
    const pageStyle = {
        width: width + "%",
        backgroundColor: color,
    };
    return (<div style={pageStyle} className="pdf-overview-segment" title={highlight.id} ></div>);
};
const PageResultSegment = ({ width }) => {
    const pageStyle = {
        width: width + "%",
        backgroundColor: "#ff6677",
    };
    return (<div style={pageStyle} className="pdf-overview-segment" ></div>);
};

const OverviewScrollbarTrack = forwardRef((props, ref) => {

    var totalHeight = 0;
    for (let index = 0; index < props.pages.length; index++) {
        const page = props.pages[index];
        totalHeight = totalHeight + page.view[3];
    }
    var style = props.style;
    const finalStyle = {
        ...style,
        right: 2,
        bottom: 2,
        top: 2,
        backgroundColor: '#eeeeee',
        width: "50px"
    };

    var pages = [];
    for (let index = 0; index < props.pages.length; index++) {

        const page = props.pages[index];
        var pageHeight = page.view[3];
        var pageHeightPerc = (100 * pageHeight) / totalHeight;
        let linesLookup = {};
        for (let i = 0; i < props.highlights.length; i++) {
            const highlight = props.highlights[i];
            if (highlight.position.pageNumber == page.pageNumber) {
                var offset = (100 * highlight.position.boundingRect.y1) / pageHeight;
                if (linesLookup[offset] == null) {
                    linesLookup[offset] = [];
                }
                linesLookup[offset].push({ highlight: highlight, offset: offset, type: "highlight" });
            }
        }

        var searchResultsInPage = props.searchResults.matches[page.pageNumber - 1];
        //console.log(props.searchResults);
        var pageResultLengths = props.searchResults.lengths[page.pageNumber - 1];
        if (searchResultsInPage) {
            for (let i = 0; i < searchResultsInPage.length; i++) {
                const searchResult = searchResultsInPage[i];

                const length = pageResultLengths[i];
                //console.log({searchResult, pageHeight});
                var offset = (100 * searchResult) / pageHeight;

                if (linesLookup[offset] == null) {
                    linesLookup[offset] = [];
                }
                linesLookup[offset].push({ length: length, offset: offset, type: "result", id: index + "_" + i });
            }
        }

        let lineKeys = [];
        for (const lineKey in linesLookup) {
            lineKeys.push(lineKey);
        }
        lineKeys.sort().reverse();
        //console.log(lineKeys);



        let lines = [];
        for (let lineIndex = 0; lineIndex < lineKeys.length; lineIndex++) {
            const lineKey = lineKeys[lineIndex];
            const line = linesLookup[lineKey];

            var segments = [];
            var totalWidth = 0;
            var maxSegmentHeight = 0;
            for (let segmentIndex = 0; segmentIndex < line.length; segmentIndex++) {
                var segment = line[segmentIndex];

                if (segment.type == "highlight") {
                    totalWidth = totalWidth + segment.highlight.position.boundingRect.x2 - segment.highlight.position.boundingRect.x1;
                    var segmentHeight = segment.highlight.position.boundingRect.y1 - segment.highlight.position.boundingRect.y2;

                    if (segmentHeight > maxSegmentHeight) {
                        maxSegmentHeight = segmentHeight;
                    }
                } else if (segment.type == "result") {
                    totalWidth = totalWidth + length;
                    var segmentHeight = 20;
                    if (segmentHeight > maxSegmentHeight) {
                        maxSegmentHeight = segmentHeight;
                    }
                }
                for (let segmentIndex = 0; segmentIndex < line.length; segmentIndex++) {
                    var segment = line[segmentIndex];
                    if (segment.type == "highlight") {
                        var myWidth = segment.highlight.position.boundingRect.x2 - segment.highlight.position.boundingRect.x1;
                        var myWidthPerc = (100 * myWidth) / totalWidth;
                        segments.push(<PageSegment key={segment.id} width={myWidthPerc} highlight={segment.highlight} />);
                    } else if (segment.type == "result") {
                        
                         var myWidthPerc = (100 * segment.length) / totalWidth;
                        segments.push(<PageResultSegment key={segment.id} width={myWidthPerc} />);
                    }
                }
                var lineHeihgtPerc = (100 * maxSegmentHeight) / pageHeight;
                lines.push(<PageLine key={lineKey} offset={100 - lineKey} height={lineHeihgtPerc}>{segments}</PageLine>);
            }
        }      
              pages.push(<PageOutline page={page.pageNumber} key={page.pageNumber} height={pageHeightPerc}>{lines}</PageOutline>);

    }

    return <div style={finalStyle} ref={ref} className="pdf-overview-track">
        <div className="pdf-overview-background">
            {pages}
        </div>
        {props.children}
    </div>;
});
export default OverviewScrollbarTrack;